module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av89-3fd23de88ab81d6fa6a2bbe44746d672.jpg";